<template>
  <div>
    <div class="bj dis-cent">
      <div class="content">
        <div class="headBox">
          <div class="title">请选择职位类别</div>
          <div class="inpBox">
            <div class="iconfont icon-search search dis-cent"></div>
            <div class="box">
              <input type="text" placeholder="请输入名称搜索" />
            </div>
          </div>
          <div class="youBox">
            <div class="iconfont icon-close close" @click="gbClick"></div>
          </div>
        </div>
        <div class="cont">
          <div class="contLeft scroll">
            <div
              class="text"
              :class="index == typeOn ? 'on' : ''"
              v-for="(item, index) in list"
              @click="typeClick(index)"
            >
              <div class="name">{{ item.name }}</div>
              <div class="num dis-cent" v-if="item.num != 0">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="contRig">
            <div class="nrCont">
              <div
                class="text dis-cent"
                :class="item.select ? 'on' : ''"
                v-for="(item, index) in contList"
                @click="contClick(index)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="diCont">
              <div class="name">已选（{{ xzList.length }}/3）</div>
              <div class="box">
                <div class="textBox dis-cent" v-for="(item, index) in xzList">
                  <div class="txt">{{ item.name }}</div>
                  <div
                    class="iconfont icon-close close"
                    @click="delClick(item, index)"
                  ></div>
                </div>
              </div>
              <div class="btn dis-cent" @click="gbClick">确认</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      typeOn: 0,
      list: [
        {
          name: "互联网",
          num: 0,
          chi: [
            {
              name: "前端开发1",
              select: false,
            },
            {
              select: false,
              name: "前端开发2",
            },
            {
              select: false,
              name: "前端开发3",
            },
            {
              select: false,
              name: "前端开发4",
            },
          ],
        },
        {
          name: "互联网",
          num: 0,
          chi: [
            {
              select: false,
              name: "前端开发5",
            },
            {
              select: false,
              name: "前端开发6",
            },
            {
              select: false,
              name: "前端开发7",
            },
            {
              select: false,
              name: "前端开发8",
            },
          ],
        },
        {
          name: "互联网",
          num: 0,
          chi: [
            {
              select: false,
              name: "前端开发9",
            },
            {
              select: false,
              name: "前端开发10",
            },
            {
              select: false,
              name: "前端开发11",
            },
            {
              select: false,
              name: "前端开发12",
            },
          ],
        },
      ],
      contOn: null,
      contList: [],
      xzList: [],
    };
  },
  props: ["zwData"],
  created() {
    this.contList = this.list[0].chi;
    this.mrfzGet();
  },
  methods: {
    gbClick() {
      this.$emit("show", { data: this.xzList });
    },
    typeClick(i) {
      this.typeOn = i;
      this.contList = this.list[i].chi;
    },
    contClick(i) {
      if (this.xzList.length >= 3) {
        if (!this.contList[i].select) {
          this.$message.warning("最多只能选择3个");
          return;
        }
      }
      this.contList[i].select = !this.contList[i].select;
      this.fzGet();
    },
    fzGet() {
      let xzList = [];
      for (let i = 0; i < this.list.length; i++) {
        const e = this.list[i];
        e.num = 0;
        for (let j = 0; j < e.chi.length; j++) {
          const ej = e.chi[j];
          if (ej.select) {
            e.num++;
            xzList.push(ej);
          }
        }
      }
      this.xzList = xzList;
    },
    // 默认赋值
    mrfzGet() {
      let xzList = [];
      for (let i = 0; i < this.list.length; i++) {
        const e = this.list[i];
        e.num = 0;
        for (let j = 0; j < e.chi.length; j++) {
          const ej = e.chi[j];
          for (let x = 0; x < this.zwData.length; x++) {
            const ex = this.zwData[x];
            if (ex.name == ej.name) {
              ej.select = true;
              e.num++;
              xzList.push(ej);
            }
          }
        }
      }
      this.xzList = xzList;
    },
    delClick(item, ins) {
      for (let i = 0; i < this.list.length; i++) {
        const e = this.list[i];
        for (let j = 0; j < e.chi.length; j++) {
          const ej = e.chi[j];
          if (ej.name == item.name) {
            console.log(j);
            e.num--;
            this.list[i].chi[j].select = false;
          }
        }
      }
      this.xzList.splice(ins, 1);
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  border-radius: 10px;
  width: 800px;
  height: 550px;
  .headBox {
    height: 70px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    .title {
      font-weight: 600;
      font-size: 18px;
      width: 220px;
    }
    .inpBox {
      width: 250px;
      height: 30px;
      border-radius: 5px;
      background-color: #f0f0f0;
      display: flex;
      .search {
        height: 30px;
        width: 40px;
        font-weight: 600;
        color: #9c9c9c;
        font-size: 18px;
      }
      .box {
        width: calc(100% - 40px);
        height: 30px;
        position: relative;
        left: -4px;
        input {
          width: 100%;
          height: 100%;
        }
      }
    }
    .youBox {
      width: 330px;
      display: flex;
      justify-content: flex-end;
      .close {
        font-weight: 600;
        font-size: 22px;
        cursor: pointer;
      }
    }
  }
  .cont {
    display: flex;
    height: calc(100% - 70px);
    .contLeft {
      width: 210px;
      border-right: 1px solid #ebebeb;
      box-sizing: border-box;
      overflow: auto;
      height: 100%;
      padding: 15px;
      .text {
        padding: 0 10px;
        height: 35px;
        border-radius: 5px;
        margin-bottom: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        .name {
          width: calc(100% - 20px);
        }
        .num {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: #fff;
          background: #147ee0;
          font-size: 12px;
        }
      }
      .on {
        background-color: #e6ecf7;
        font-weight: 600;
        color: #147ee0;
      }
      .text:hover {
        background-color: #e6ecf7;
        color: #147ee0;
        font-weight: 600;
      }
    }
    .contRig {
      width: calc(100% - 210px);
      overflow: hidden;
      position: relative;
      .nrCont {
        padding: 20px;
        height: 100%;
        box-sizing: border-box;
        width: 100%;
        .text {
          float: left;
          margin-bottom: 10px;
          padding: 0 13px;
          height: 30px;
          border-radius: 5px;
          background-color: #eef1f5;
          border: 1px solid #eef1f5;
          color: #000;
          margin-right: 10px;
          cursor: pointer;
          box-sizing: border-box;
        }
        .text:hover {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
        .on {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
      }
      .diCont {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px;
        display: flex;
        align-items: center;
        .name {
          width: 80px;
        }
        .box {
          width: calc(100% - 160px);
          display: flex;
          .textBox {
            height: 30px;
            border-radius: 5px;
            background-color: #e6ecf7;
            padding: 0 6px 0 10px;
            margin-right: 10px;
            .close {
              font-size: 12px;
              position: relative;
              top: 2px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
        }
        .btn {
          width: 80px;
          height: 38px;
          border-radius: 38px;
          background-color: #147ee0;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
